import { NavigationBarAlertService } from './app_nav_bar/services/navigation_bar_alert_service';
import { AppNavBarComponent, AppNavBarController } from './app_nav_bar/app_nav_bar';
import { NavigationHistoryStack } from './app_nav_bar/services/navigation_history_stack';
require('angular-ui-router');
/**
 * @phxNavbar
 */

angular
  .module('ui-ng-navbar', ['ui.router'])
  .service('ngNavigationHistoryStack', NavigationHistoryStack)
  .service('ngNavigationBarAlertService', NavigationBarAlertService)
  .component('appNavBar', new AppNavBarComponent())
  .controller('AppNavBarController', AppNavBarController);

export * from './nav_bar_interfaces';
export * from './app_nav_bar/services/navigation_bar_alert_service';
export * from './app_nav_bar/services/navigation_history_stack';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-navbar/src/main.ts